import {
  updateResourceState,
  createResourceReducer,
  RESOURCE
} from 'react-structure-admin';
import {
  INBOUND_INVOICE,
  INBOUND_INVOICE_REFRESH
} from './inboundInvoiceActions';

const inboundInvoiceReducer = createResourceReducer(INBOUND_INVOICE, [], {
  [INBOUND_INVOICE_REFRESH](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loaded: false
    }));
  }
});

export default inboundInvoiceReducer;
